export const EVENTS_AVAILABLES = [
    { id: 1, name: 'Noticia', value: 'notices' },
    { id: 2, name: 'Evento', value: 'events' }
  ]
